/**
 * Vendor program header block for call to action (CTA)
 */
import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Table, TableBody, TableContainer, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
    root: {
        flexGrow: 1,
    },
    tblHead: {
      backgroundColor: '#f1f1f1'
    }
});

class VendorPartnerProgramBlockCta extends Component {

  render() {
    const classes = this.props.classes;

    let vpp = this.props.vpp;
    let ctaTitle = vpp.ctaTitle;
    let ctaText = vpp.ctaText;
    let cp = vpp.cpTByCtaCpId;
    let programLines = null;
    if (cp != null) {
      programLines = cp.cpLineTsByCpId.nodes;
    }
    //let devMode = this.props.devMode;
  
    // In stage 0, the CTA block will talk about programs that are available, and what kind of benefits are available
    // - if there is a relevant commission program, show it
    if (this.props.vppRelationship.stage === 0) {
      return (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography variant="h6">{ctaTitle}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2">{ctaText}</Typography>
              </Grid>
            </Grid>
          </Grid>
          {cp != null &&
          <Grid item xs={12}>
            <Grid container spacing={2} direction="row" justifyContent="space-between">
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography variant="h6">{cp.programName}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2">{cp.description}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={0} direction="column" justifyContent="flex-start">
                  <Grid item xs={12}> 
                    {cp.programType === 0 &&
                    <Typography variant="body2">                                                          
                      <b>Instant rebate</b>
                    </Typography>}
                    {cp.programType === 1 &&
                    <Typography variant="body2">                                                             
                      <b>Monthly rebate</b>
                    </Typography> }
                    {cp.programType === 2 &&
                    <Typography variant="body2">          
                      Monthly credits
                    </Typography>}
                    {cp.programType === 3 &&
                    <Typography variant="body2">                           
                      Prepaid credits
                    </Typography>}
                    {cp.programType === 4 &&
                    <Typography variant="body2">                           
                      Referral
                    </Typography>}
                  </Grid>
                  <Grid item xs={12}>
                    {cp.programType === 0 &&
                    <Typography variant="body2">                            
                      Wholesale discounts on subscriptions purchased through AppBind are applied immediately on every charge.
                    </Typography>}
                    {cp.programType === 1 &&
                    <Typography variant="body2">                            
                      At the end of the month, a sales commission is calculated based on volume during the month, and paid out as a rebate.
                    </Typography>}
                    {cp.programType === 2 &&
                    <Typography variant="body2">                            
                      At the end of the month, a sales commission is calculated based on volume during the month, and paid out as credits that can be applied to future purchases.
                    </Typography>}
                    {cp.programType === 3 &&
                    <Typography variant="body2">                            
                      Purchase credits up front at a discount.
                    </Typography>}
                    {cp.programType === 4 &&
                    <Typography variant="body2">                            
                      At the end of the month, a sales commission is calculated based on volume imported from external system, and paid out as a rebate.
                    </Typography>}
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <TableContainer>
                  <Table>
                    <TableHead className={classes.tblHead}>
                      <TableRow>
                        <TableCell align="right">Minimum sales</TableCell>
                        <TableCell align="right">Incentive percentage</TableCell>
                        {/*<TableCell align="center">{deleteHeader}</TableCell>*/}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {programLines && programLines.map(line => {
                        let revenue = line.revenueMin;
                        let perc    = line.incentivePerc;

                        let revenueFormatted = Number(revenue)
                          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                        return(
                          <TableRow key={line.resellerPlId}>
                            <TableCell align="right">
                              {revenueFormatted}                                  
                            </TableCell>
                            <TableCell align="right">
                              {perc}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Grid>}

          <Grid item xs={12}/>

          {this.props.formPresent &&
          <Grid item xs={12}>
            <Button color="primary" variant="contained"
              onClick={this.props.showProgramForm}
            >
              {vpp.ctaButton}
            </Button>
          </Grid>}
          {!this.props.formPresent &&
          <Grid item xs={12}>
            <Button color="primary" variant="contained"
              onClick={() => {this.updateStage();}}
            >
              {vpp.ctaButton}
            </Button>
          </Grid>}
        </Grid>
      );
    } else if (this.props.vppRelationship.stage === 1) {
      return (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography variant="h6">{ctaTitle}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2">{ctaText}</Typography>
              </Grid>
            </Grid>
          </Grid>
          {cp != null &&
          <Grid item xs={12}>
            <Grid container spacing={2} direction="row" justifyContent="space-between">
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography variant="h6">{cp.programName}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2">{cp.description}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={0} direction="column" justifyContent="flex-start">
                  <Grid item xs={12}> 
                    {cp.programType === 0 &&
                    <Typography variant="body2">                                                          
                      <b>Instant rebate</b>
                    </Typography>}
                    {cp.programType === 1 &&
                    <Typography variant="body2">                                                             
                      <b>Monthly rebate</b>
                    </Typography> }
                    {cp.programType === 2 &&
                    <Typography variant="body2">          
                      Monthly credits
                    </Typography>}
                    {cp.programType === 3 &&
                    <Typography variant="body2">                           
                      Prepaid credits
                    </Typography>}
                    {cp.programType === 4 &&
                    <Typography variant="body2">                           
                      Referral
                    </Typography>}
                  </Grid>
                  <Grid item xs={12}>
                    {cp.programType === 0 &&
                    <Typography variant="body2">                            
                      Wholesale discounts on subscriptions purchased through AppBind are applied immediately on every charge.
                    </Typography>}
                    {cp.programType === 1 &&
                    <Typography variant="body2">                            
                      At the end of the month, a sales commission is calculated based on volume during the month, and paid out as a rebate.
                    </Typography>}
                    {cp.programType === 2 &&
                    <Typography variant="body2">                            
                      At the end of the month, a sales commission is calculated based on volume during the month, and paid out as credits that can be applied to future purchases.
                    </Typography>}
                    {cp.programType === 3 &&
                    <Typography variant="body2">                            
                      Purchase credits up front at a discount.
                    </Typography>}
                    {cp.programType === 4 &&
                    <Typography variant="body2">                            
                      At the end of the month, a sales commission is calculated based on volume imported from external system, and paid out as a rebate.
                    </Typography>}
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <TableContainer>
                  <Table>
                    <TableHead className={classes.tblHead}>
                      <TableRow>
                        <TableCell align="right">Minimum sales</TableCell>
                        <TableCell align="right">Incentive percentage</TableCell>
                        {/*<TableCell align="center">{deleteHeader}</TableCell>*/}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {programLines && programLines.map(line => {
                        let revenue = line.revenueMin;
                        let perc    = line.incentivePerc;

                        let revenueFormatted = Number(revenue)
                          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                        return(
                          <TableRow key={line.resellerPlId}>
                            <TableCell align="right">
                              {revenueFormatted}                                  
                            </TableCell>
                            <TableCell align="right">
                              {perc}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Grid>}

          <Grid item xs={12}/>
          <Grid item xs={12}>
            <Typography variant="body1">{vpp.ctaLabel}</Typography>
          </Grid>

        </Grid>
      );
    } else {

      if (this.props.vppRelationship.stage === 3) {
        ctaTitle = vpp.ctaTitleSuspend;
        ctaText = vpp.ctaTextSuspend;
      } else if (this.props.vppRelationship.stage === 4) {
        ctaTitle = vpp.ctaTitleDecline;
        ctaText = vpp.ctaTextDecline;
      } else if (this.props.vppRelationship.stage === 5) {
        ctaTitle = vpp.ctaTitleLeft;
        ctaText = vpp.ctaTextLeft;
      }

      return (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography variant="h6">{ctaTitle}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2">{ctaText}</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    }
  }

  /*
  openApplyForm() {
    // Call the form passed down through props
    alert('Try to open the form');
    this.props.showProgramForm();
  }
  */

  updateStage() {
    if (this.props.devMode === true) {
      return;
    }
    this.setState({ showSecondarySpinner: true });
    const { callPartnerApi } = this.props.auth;

    let aPjwt = abEnvironment.getPjwt();


    let payload = {
      operation: "resellerApplyToProgram",
      params: {
        pJwt: aPjwt,
        pAccountId: abEnvironment.getUserAttribute('a_id'),
        vpprId: this.props.vppRelationship.vpprId
      }
    };

    //console.log(JSON.stringify(payload));

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {
      
        //a better approach is a callback to parent and re-query but for now.
        window.location.reload();
    

    })
    .catch(error => {
      //a better approach is a callback to parent and re-query but for now.
      window.location.reload();
    });
  }

}
  
export default withStyles(styleSheet)(VendorPartnerProgramBlockCta);